import { render, staticRenderFns } from "./LihatRekapitulasi.vue?vue&type=template&id=870c14ca&scoped=true"
import script from "./LihatRekapitulasi.vue?vue&type=script&lang=js"
export * from "./LihatRekapitulasi.vue?vue&type=script&lang=js"
import style0 from "./LihatRekapitulasi.vue?vue&type=style&index=0&id=870c14ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870c14ca",
  null
  
)

export default component.exports